import { baseApi } from ".";

export type SuggestDocType =
  | "national_id"
  | "passport"
  | "bank_certificate"
  | "diploma"
  | "military_certificate"
  | "enrollment_certificate"
  | "invoice"
  | "employment_record_book";

export interface SuggestInvoiceItem {
  name: string;
  nomenclature_number: string;
  unit: string;
  quantity: string;
  unit_price: string;
  total_with_vat: string;
  vat_amount: string;
}

export interface EmploymentRecordItem {
  employer_name: string;
  employer_bin: string;
  position: string;
  start_date: string;
  end_date: string | null;
  is_current: boolean;
}

export type SuggestFieldsItem = SuggestInvoiceItem | EmploymentRecordItem;

export interface SuggestFieldsResponse {
  doc_type: string;
  fields: Record<string, string>;
  items?: SuggestFieldsItem[];
}

export interface SuggestFieldsArgs {
  file: File;
  doc_type: SuggestDocType;
  token?: string;
}

const SUGGEST_TIMEOUT_MS = 60000;

export const documentSuggestApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    suggestDocumentFields: builder.mutation<SuggestFieldsResponse, SuggestFieldsArgs>({
      query: ({ file, doc_type, token }) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("doc_type", doc_type);
        return {
          url: token ? `/api/hr/apply/${token}/suggest-fields/` : `/api/hr/documents/suggest-fields/`,
          method: "POST",
          body: formData,
          credentials: "include" as const,
          timeout: SUGGEST_TIMEOUT_MS,
        };
      },
    }),
  }),
});

export const { useSuggestDocumentFieldsMutation } = documentSuggestApi;
